/**
 * Compara dois valores e retorna `true` se forem iguais.
 *
 * @param {*} x - Valor atual.
 * @param {*} y - Valor de comparação.
 * @returns {boolean} `true` se `x == y`, senão `false`.
 */
export function equals(x, y) {
  return x == y;
}
